import AppHome from "@views/app/app-home.vue";
import { dashboardRoutes } from "@/app/router/dashboard/dashboard-routes";
import { seznamPogodbRoutes } from "@/app/router/contract-list/contract-list-routes";
import { seznamDokoncanjePogodbRoutes } from "@/app/router/contract-completion/contract-completion-routes";
import { profilRoutes } from "@/app/router/profile/profile-routes";
import { contractCreateRoutes } from "@/app/router/contract-create/contract-create-routes"
import { informativeCalculationRoutes } from "./informative-calculation/informative-calculation-routes";
import { userCenterRoutes } from "./user-center-info/user-center-info-routes";
import { trainingsRoutes } from "./user-center-trainings/user-center-trainings-routes";
import { contactRoutes } from "./user-center-contact/user-center-contact-routes";
import { userCenterNewRoutes } from "./user-center-new/user-center-new-routes";
import { limitCalculationRoutes } from "./limit-calculation/limit-calculation-routes";
import { apiOrderRoutes } from "./api-order/api-order";
import { posOrderRoutes } from "./pos-order/pos-order";

export const appRoutes = [
    {
        children: [
            ...dashboardRoutes,
            ...seznamPogodbRoutes,
            ...seznamDokoncanjePogodbRoutes,
            ...profilRoutes,
            ...contractCreateRoutes,
            ...posOrderRoutes,
            ...informativeCalculationRoutes,
            ...userCenterRoutes,
            ...trainingsRoutes,
            ...contactRoutes,
            ...userCenterNewRoutes,
            ...limitCalculationRoutes,
            ...apiOrderRoutes
            ],
        component: AppHome,
        name: "app_home",
        path: "/app",
        //redirect: "/app/dashboard", // this is the default home view
    },
];
